export default React.createContext();
